import { Unit } from '@thro-types/leihbar';

export enum AvailabeUnitsReactionTime {
  MINUTE = Unit.MINUTE,
  HOUR = Unit.HOUR,
  DAY = Unit.DAY
}

export type DailyView = 'returns' | 'pickups';
